import React, { FC } from 'react'

const CrossIcon: FC = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.72063 7.78062C7.01329 8.07328 7.4878 8.07328 7.78047 7.78062C8.07313 7.48797 8.07313 7.01349 7.78047 6.72083L5.06002 4.00051L7.7805 1.28015C8.07317 0.987492 8.07317 0.513007 7.7805 0.220354C7.48783 -0.0722998 7.01333 -0.0722995 6.72066 0.220354L4.00019 2.94071L1.27934 0.219979C0.98667 -0.0726753 0.512165 -0.0726749 0.2195 0.219978C-0.0731663 0.512632 -0.0731668 0.987117 0.219499 1.27977L2.94035 4.00051L0.219536 6.72121C-0.07313 7.01386 -0.0731299 7.48835 0.219536 7.781C0.512202 8.07365 0.986707 8.07365 1.27937 7.781L4.00019 5.0603L6.72063 7.78062Z"
      fill="currentColor"
    />
  </svg>
)

export default CrossIcon
